import { Box, Skeleton } from "@mui/material";
import { DotLegalEmptyState } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import EmptyRecord from "../../record/emptyRecord.svg?react";
import { useDataProcessorRecordStyles } from "./DataProcessorRecord.styles";
import { DataProcessorRecordTableModel } from "./DataProcessorRecord.types";
import DataProcessorRecordGroup from "./DataProcessorRecordGroup";

const loadingRowCount = 6;

export interface DataProcessorRecordGroupsProps {
    groups: Array<DataProcessorRecordTableModel>;
    isLoading: boolean;
}

// The tables stack one per data controller, so they cannot each fill the paper the way a single list does. They scroll
// together below whatever heads them instead.
function DataProcessorRecordGroups(props: DataProcessorRecordGroupsProps) {
    const { translateString } = useTranslation();
    const styles = useDataProcessorRecordStyles();

    if (props.isLoading) {
        return (
            <Box>
                {Array.from({ length: loadingRowCount }, (_, index) => (
                    <Skeleton key={index} sx={styles.skeleton} variant="rounded" />
                ))}
            </Box>
        );
    }

    if (props.groups.length === 0) {
        return <DotLegalEmptyState icon={<EmptyRecord />} text={translateString("noProcessingActivitesMatchesQuery")} />;
    }

    return (
        <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", marginTop: 2, display: "flex", flexDirection: "column", gap: 3 }}>
            {props.groups.map((group, index) => (
                <DataProcessorRecordGroup key={group.name + index} group={group} />
            ))}
        </Box>
    );
}

export default DataProcessorRecordGroups;
